// extracted by mini-css-extract-plugin
export default {"container":"lof7Jl4"};